import React from "react";

function Phone() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M6.632 3.76l-.336-.755c-.22-.493-.329-.74-.493-.93a1.673 1.673 0 00-.773-.502C4.79 1.5 4.52 1.5 3.98 1.5c-.79 0-1.185 0-1.517.152a1.77 1.77 0 00-.884.974c-.12.344-.085.699-.017 1.407.728 7.542 4.863 11.677 12.405 12.405.708.068 1.063.102 1.407-.017a1.77 1.77 0 00.974-.884c.152-.332.152-.727.152-1.517 0-.54 0-.81-.073-1.05a1.672 1.672 0 00-.503-.773c-.189-.164-.435-.274-.93-.493l-.754-.336c-.535-.238-.802-.356-1.074-.382a1.674 1.674 0 00-.765.106c-.254.1-.479.287-.928.661-.448.373-.671.56-.945.66a1.8 1.8 0 01-.818.083c-.288-.043-.508-.16-.949-.396-1.372-.733-2.128-1.49-2.861-2.861-.236-.44-.354-.661-.396-.95a1.8 1.8 0 01.084-.817c.1-.273.286-.497.659-.945.374-.449.562-.674.66-.928.095-.243.132-.505.107-.765-.026-.272-.145-.54-.382-1.074z"
      ></path>
    </svg>
  );
}

export default Phone;
